import { userDeviceDetect } from "utils";
import { routeObject } from "typings";
import { scapeQueryParams } from "utils/scapeQueryParams/scapeQueryParams";

export const redirectRoutes: routeObject = {
  "/ajuda": () => {
    const queryParams = window.location.search;
    const scapedQueryParams = scapeQueryParams(queryParams);
    window.location.href = `https://ajuda.nav.com.br/s/${scapedQueryParams}`;
  },
  "/app": () => {
    if (userDeviceDetect().isAndroid) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=br.com.nav";
      return;
    }
    if (userDeviceDetect().isIos) {
      window.location.href = "https://apps.apple.com/br/app/nav/id1553834596";
      return;
    }
    window.location.href = "/login";
  },
  "/profissionais-da-saude": () =>
    (window.location.href = "http://pro-nav.dasa.com.br"),
};
